<p>{{ data.message }}</p>
<div *ngIf="data.type === 'alert' && data.ignorePermission">
    <button mat-button (click)="ignoreAlerts($event)">Ignorieren</button>
</div>
